// src/api/userGroupApi.js
import axiosClient from "./axiosClient";

const userGroupApi = {
  searchUserGroups: (customerId, searchKeyword, page, pageSize, isActive) => {
    const body = {
      customerId: customerId,
      searchKeyword: searchKeyword,
      pageNumber: page > 0 ? page + 1 : 1,
      pageSize: pageSize,
      isActive: isActive,
    };

    return axiosClient.post(`/user_groups/search`, body, {
      withCredentials: true,
    });
  },
  upsertUserGroup: (ugId, ugName, ugDescription, ugIsActive, customerId) => {
    let data = {
      ugId: ugId,
      ugName: ugName,
      ugDescription: ugDescription,
      ugIsActive: ugIsActive,
      customerId: customerId,
    };
    return axiosClient.post("/user_groups/upsert", data, {
      withCredentials: true,
    });
  },
  deleteUserGroup: (itId) => {
    return axiosClient.delete(`/user_groups/${itId}`, {
      withCredentials: true,
    });
  },
};

export default userGroupApi;
